export function setLocalStorageItems(hash: {[key: string]: any}) {
  Object.keys(hash).forEach(key => {
    window.localStorage.setItem(key, hash[key])
  })
}
